var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"divider",class:{ 'divider--dark': _vm.dark }})
}
var staticRenderFns = []

export { render, staticRenderFns }